const GROUP_HOME_PAGES: Array<{ group: string; path: string }> = [
  { group: "Operations", path: "/operations" },
  { group: "Operations Manager", path: "/operations" },
  { group: "Sales Rep", path: "/sales" },
  { group: "Sales", path: "/sales" },
];

export function getHomePage(groupNames?: string[] | null): string {
  if (!groupNames?.length) return "/app-home";
  for (const { group, path } of GROUP_HOME_PAGES) {
    if (groupNames.includes(group)) return path;
  }
  return "/app-home";
}
